/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FolderPersonal16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M2.615 3h3.231C6.923 3 6.654 4.048 8 4.048h5.385c.892 0 1.615.703 1.615 1.571v6.81c0 .867-.723 1.571-1.615 1.571H2.615C1.723 14 1 13.296 1 12.429V4.57C1 3.704 1.723 3 2.615 3z"
        />
    </AccessibleSVG>
);

export default FolderPersonal16;
